import PromisedResource from './PromisedResource'

export default class ProgramGroupsResource extends PromisedResource {
  constructor({ remote, client }) {
    super(remote.query(q => q.findRelatedRecords(client, 'programGroups')))
  }
}
